import { isNull } from "../predicates";

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}( |T)\d{2}:\d{2}:\d{2}.\d{2,6}(|Z)$/g;
const FRONT_DATE_REGEX = /\d{2}\/\d{2}\/\d{4}, \d{2}:\d{2}:\d{2}/g;

export const isValidDate = (date: string) =>
  !isNull(date.match(DATE_REGEX) || date.match(FRONT_DATE_REGEX));
